module.exports = __webpack_public_path__ + "static/img/li11_1.220e52a6.png";